import { FAILURE } from '@front/common/constants'
import { getCustomer, putCustomer, resubscribe } from '@front/common/endpoints'
import { Customer } from '@front/common/types'
import useAlert from '@front/ui/Alert/useAlert'
import { Ref, watch } from '@vue/composition-api'
import { useStore, useVuex } from '@vueblocks/vue-use-vuex'

import useApiState from '@member-area/core/hooks/useApiState'
import useAuth from '@member-area/middleware/auth.hook'

import { INSERT_CUSTOMER, UPDATE_CUSTOMER } from './constants'

const useCustomer = () => {
  const store = useStore()
  const { useGetters } = useVuex()
  const { triggerAlert } = useAlert()
  const { auth } = useAuth()

  const [
    onFetchCustomerSuccess,
    fetchCustomerState,
    fetchCustomerAction,
  ]: any[] = useApiState(getCustomer)
  const [onUpdateCustomerSuccess, updateCustomerState, updateCustomer]: any[] =
    useApiState(putCustomer)
  const [
    onResubscribeSuccess,
    resubscribeState,
    resubscribeCustomerAction,
  ]: any[] = useApiState(resubscribe)

  onUpdateCustomerSuccess((data) => {
    if (!data) {
      return
    }

    store.commit(UPDATE_CUSTOMER, data)
  })

  onFetchCustomerSuccess((data) => {
    if (!data) {
      return
    }

    store.commit(INSERT_CUSTOMER, data)
  })

  watch(fetchCustomerState, (state: any) => {
    if (state.value === FAILURE) {
      triggerAlert({
        status: FAILURE,
        message: 'Une erreur est survenue, veuillez recharger la page',
      })
    }
  })

  async function resubscribeCustomer(promoCode = '') {
    return resubscribeCustomerAction(auth.value.id, promoCode)
  }

  async function fetchCustomer() {
    return fetchCustomerAction(auth.value.id)
  }

  return {
    ...(useGetters({
      customer: 'customer/get',
    }) as { customer: Ref<Customer> }),
    fetchCustomerState,
    updateCustomerState,
    resubscribeState,
    onResubscribeSuccess,
    fetchCustomer,
    updateCustomer,
    resubscribeCustomer,
  }
}

export default useCustomer
